<div class="iframe-container">
    <iframe [src]="this.iframeUrl" data-testid="order-history-iframe"></iframe>
</div>
